export const ROUTE_PATHS = { HOME: '/' } as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  category: string;
}
export interface Stat { value: string; label: string; }
export interface NavItem { label: string; href: string; }

export interface TimelineItem {
  year: string;
  role: string;
  company: string;
  sector: string;
  description: string;
  type: 'current' | 'past';
}
export interface Testimonial {
  quote: string;
  name: string;
  title: string;
  company: string;
  initials: string;
  category?: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'About', href: 'about' },
  { label: 'Services', href: 'services' },
  { label: 'Partners', href: 'partners' },
  { label: 'Contact', href: 'contact' },
];
